import { DistanceUnits } from '../types.results'
import { UnitType } from '@eventops/athlinks-lib-units'

export const distanceUnitToUnitType = (distanceUnit?: DistanceUnits) =>
  distanceUnit
    ? ['m', '100m', 'km'].includes(distanceUnit)
      ? UnitType.METRIC
      : UnitType.IMPERIAL
    : UnitType.DEFAULT
